import Tiers from './Tiers';

export default Tiers;
